import * as Sentry from '@sentry/vue'
import debug from 'debug'
import { ParsePresXML } from 'Store/class/helper'

const dbg = debug('store:settings:mutations:')

export default {
  RESET (state) {
    state.dnd = false
    state.callwaiting = false
    state.intercom.deskphone = false
    state.intercom.callpanel = false
    state.intercom.anywhere = false
    state.showMissedCalls = true
    state.callfwd.enabled = false
    state.callfwd.number = null
    state.followme.enabled = false
    state.followme.confirm = false
    state.followme.markAnswered = false
    state.followme.prefix = null
    state.followme.timeConditionID = 0
    state.followme.timeConditions = []
    state.followme.toutall = 0
    state.followme.toutfirst = 0
    state.followme.numbers = []
    state.followme.strategy = 'ringall'
    state.emergecyCID.disabledGlobally = false
    state.emergecyCID.pID = 0
    state.emergecyCID.lID = 0
    state.screenPop.type = ''
    state.screenPop.trigger = ''
    state.screenPop.url = ''
    state.showMissedCalls = true
    state.dids = []
  },

  INIT (state, data) {
    state.dnd = Boolean(data.dnd)
    state.callwaiting = Boolean(data.callwaiting)
    state.intercom.deskphone = data.intercom.deskPhoneEnabled === '1'
    state.intercom.callpanel = data.intercom.callPanelEnabled === '1'
    state.intercom.anywhere = data.intercom.clearlyAnywhereEnabled === '1'
    state.showMissedCalls = data.show_missed_calls
    state.callfwd.enabled = data.forward !== null
    state.callfwd.number = data.forward

    if (data.followme) {
      state.followme.enabled = data.followme.enabled
      state.followme.confirm = ~~data.followme.prompt === 1
      state.followme.prefix = data.followme.clid_prefix
      state.followme.toutall = ~~data.followme.timeout
      state.followme.toutfirst = ~~data.followme.delay
      state.followme.externCID = data.followme.extern_cid
      state.followme.externCIDName = data.followme.extern_cid_name
      state.followme.externCIDNum = data.followme.extern_cid_num
      state.followme.strategy = data.followme.strategy
      state.followme.markAnswered = Boolean(data.followme?.mark_answered_elsewhere)
      state.followme.numbers = data.followme.to ? data.followme.to.split(',') : []
      state.followme.timeConditionID = ~~data.followme.time_condition_id
      state.followme.timeConditions = []
    }

    if (data.screenPop) {
      state.screenPop.type = data.screenPop.type
      state.screenPop.trigger = data.screenPop.trigger
      state.screenPop.url = data.screenPop.url
    }

    if (data.otp?.success && data.otp?.data) {
      const otp = data.otp.data
      state.OTP.enabled = otp.otp_enabled
      state.OTP.method = otp.otp_method
      state.OTP.smsAvailable = otp.otp_sms_available
      state.OTP.email = otp.otp_email
      state.OTP.phoneNum = otp.otp_phone_number
      state.OTP.provURI = otp.otp_provisioning_uri
      state.OTP.backupCodes = otp.otp_backup_codes
    }

    state.showMissedCalls = data?.show_missed_calls || '0'
    state.dids = data?.dids || []
  },

  SET_CURRENT_USER (state, data) {
    state.user.id = ~~data.id
    state.user.email = data.email
    state.user.realm = data.realm
    state.user.username = data.username
    state.user.firstName = data.first_name
    state.user.lastName = data.last_name
    state.ownerID = state.user.id
    state.emergecyCID.pID = data.emergency_callerid_callback_profile_id
    state.emergecyCID.lID = data.emergency_callerid_dispatchable_location_id

    Sentry.setUser({
      id: state.user.id,
      email: state.user.email,
      username: state.user.username
    })
    Sentry.setTag('realm', state.user.realm)
  },

  SET_SUB_ACCOUNTS (state, list) {
    if (!list) {
      dbg('Invalid sub accounts list')
      return
    }
    state.subAccounts.splice(0)
    const listSorted = Object.entries(list).map(([_, data]) => data)
      .sort((a, b) => a.username?.localeCompare(b.username))
    for (const acc of listSorted) {
      state.subAccounts.push({ ...acc, name: `${acc.first_name} ${acc.last_name}` })
    }
  },

  SET_DND (state, enabled) {
    state.dnd = enabled
  },

  SET_INTERCOM (state, { enabled, icom }) {
    if (icom) {
      state.intercom[icom] = enabled
    }
  },

  INIT_INTERCOM (state, data) {
    state.intercom.deskphone = data?.deskPhoneEnabled === '1'
    state.intercom.callpanel = data?.callPanelEnabled === '1'
    state.intercom.anywhere = data?.clearlyAnywhereEnabled === '1'
  },

  SET_CALLWAIT (state, enabled) {
    state.callwaiting = enabled
  },

  SET_CALLFWD (state, data) {
    dbg('update call forward: %o', data)
    state.callfwd.enabled = data.enabled
    state.callfwd.number = data.number
  },

  SET_FOLLOWME_ALL (state, data) {
    if (!data) return
    state.followme.enabled = !!data.enabled
    state.followme.confirm = ~~data.prompt === 1
    state.followme.markAnswered = !!data.mark_answered_elsewhere
    state.followme.prefix = data.clid_prefix
    state.followme.externCID = data.extern_cid
    state.followme.externCIDName = data.extern_cid_name
    state.followme.externCIDNum = data.extern_cid_num
    state.followme.strategy = data.strategy
    state.followme.toutall = ~~data.timeout
    state.followme.toutfirst = ~~data.delay
    state.followme.timeConditionID = ~~data.time_condition_id
    state.followme.numbers = data.to
      ? data.to.split(',')
      : []
  },

  SET_FOLLOWME_ENABLED (state, val) {
    state.followme.enabled = val
  },

  SET_FOLLOWME_CONFIRM (state, val) {
    state.followme.confirm = val
  },

  SET_FOLLOWME_ANSWERED_ELSEWHERE (state, val) {
    state.followme.markAnswered = val
  },

  SET_FOLLOWME_PREFIX (state, val) {
    state.followme.prefix = val
  },

  SET_FOLLOWME_CLIENTCID (state, val) {
    state.followme.externCID = val
  },

  SET_EXTERN_CID_NAME (state, val) {
    state.followme.externCIDName = val
  },

  SET_EXTERN_CID_NUM (state, val) {
    state.followme.externCIDNum = val
  },

  SET_FOLLOWME_TOUT_ALL (state, val) {
    state.followme.toutall = ~~val
  },

  SET_FOLLOWME_TOUT_FIRST (state, val) {
    state.followme.toutfirst = ~~val
  },

  DEL_FOLLOWME_NUM (state, num) {
    const idx = state.followme.numbers.indexOf(num)
    if (idx !== -1) {
      state.followme.numbers.splice(idx, 1)
    }
  },

  SET_FME_TIME_COND_LIST (state, data) {
    state.followme.timeConditions = data
  },

  SET_FME_TIME_COND_ID (state, id) {
    state.followme.timeConditionID = ~~id
  },

  SET_FEATURE_CODES (state, data) {
    if (!data || !Array.isArray(data)) {
      dbg('WARN: failed to set feature codes. Empty data. Will use defaults')
      return
    }
    for (const fc of data) {
      switch (fc.usr_attribute) {
        case 'cfwd':
          state.featureCodes.forward = fc.code
          break
        default:
          state.featureCodes[fc.usr_attribute] = fc.code
          break
      }
    }
  },

  SET_FOLLOWME_NUMBERS (state, numbers) {
    state.followme.numbers = numbers
  },

  SET_FOLLOWME_STRATEGY (state, strategy) {
    state.followme.strategy = strategy
  },

  SET_ECID_PROFILE_ID (state, id) {
    state.emergecyCID.pID = ~~id
  },

  SET_ECID_LOCATION_ID (state, id) {
    state.emergecyCID.lID = ~~id
  },

  SET_EMERGENCY (state, { profiles, locations }) {
    if (profiles?.clearly_emergency_disabled ||
      locations?.clearly_emergency_disabled) {
      state.emergecyCID.disabledGlobally = true
      dbg('WARN: Emergency profiles are globally disabled!')
      return
    }
    if (!profiles?.success && !locations?.success) {
      dbg('WARN: Failed to get emergency profiles')
      return
    }
    state.emergecyCID.disabledGlobally = false
    state.emergecyCID.profiles = profiles.data ?? []
    state.emergecyCID.locations = locations.data ?? []
  },

  SET_USERNAME (state, name) {
    state.user.username = name
  },

  SET_USERREALM (state, realm) {
    state.user.realm = realm
  },

  SET_USEREMAIL (state, email) {
    state.user.email = email
  },

  SET_OTP_ALL (state, data) {
    if (data?.success !== true) {
      dbg('WARN: no OTP data to setup')
      return
    }

    const otp = data.data
    state.OTP.enabled = otp.otp_enabled
    state.OTP.method = otp.otp_method
    state.OTP.smsAvailable = otp.otp_sms_available
    state.OTP.email = otp.otp_email
    state.OTP.phoneNum = otp.otp_phone_number
    state.OTP.provURI = otp.otp_provisioning_uri
    state.OTP.backupCodes = otp.otp_backup_codes
  },

  SET_OTP_OPT (state, { opt, val }) {
    state.OTP[opt] = val
  },

  SET_OTPENABLED (state, enabled) {
    state.OTP.enabled = enabled
  },

  SET_CTD_ALL (state, data) {
    state.clickToDial.destination = data?.destination
  },

  SET_CTD_DESTINATION (state, destination) {
    state.clickToDial.destination = destination
  },

  SET_SCREEN_POP (state, data) {
    state.screenPop.type = data?.type
    state.screenPop.trigger = data?.trigger
    state.screenPop.url = data?.url
  },

  SET_SCREEN_POP_TYPE (state, type) {
    state.screenPop.type = type
  },

  SET_SCREEN_POP_TRIGGER (state, trigger) {
    state.screenPop.trigger = trigger
  },

  SET_SCREEN_POP_URL (state, url) {
    state.screenPop.url = url
  },

  SET_OWNER_ID (state, id) {
    state.ownerID = id
  },

  SET_SHOW_MISSED_CALLS (state, enabled) {
    state.showMissedCalls = enabled
  },

  SET_CLEARLY_ANYWHERE_LANDING_PAGE (state, clearlyAnywhereLandingPage) {
    state.clearlyAnywhereLandingPage = clearlyAnywhereLandingPage
  },

  SET_NOTIFICATIONS (state, notifications) {
    state.notifications = notifications
  },

  SET_DIDS (state, dids) {
    state.dids = dids
  },

  FEATURE_SET (state, { data, exten }) {
    const { error, remote: rURI, local: lURI } = ParsePresXML(data.body)
    if (error) {
      dbg('WARN: failed to parse presence body: %o', error)
      return
    }

    if (!(rURI.user === exten && rURI.host === state.user.realm) &&
      !(lURI.user === exten && lURI.host === state.user.realm)) {
      dbg(`Local user does not match identities '${lURI}' or '${rURI}'`)
      return
    }

    switch (data.featureName) {
      case 'dnd':
        state.dnd = data.featureValue === 'on'
        break
      case 'forward':
        state.callfwd.enabled = !(data.featureValue === 'off')
        state.callfwd.number = data.featureValue === 'off'
          ? null
          : data.featureValue
        break
      case 'followme':
        state.followme.enabled = data.featureValue === 'on'
        break
      default:
        dbg(`Unknown feature name: '${data.featureName}'`)
        break
    }
  },

  SET_BLACKLIST (state, list = []) {
    state.blacklist = list
  },

  ADD_BLACKLIST (state, item) {
    state.blacklist.push(item)
  },

  REMOVE_BLACKLIST (state, item) {
    state.blacklist = state.blacklist.filter(i => i.id !== item.id)
  }
}
